import { reactive } from "vue";
import { Log } from "~/extensions/utils";
import { api } from "../api";
import { HanyoListViewModel } from "~/extensions/models/HanyoListViewModel";
import { auth } from "../core";
import { MypageTableSetting } from "~/api/data/Common/GetSettingResult";
import { GetDomainResult } from "src/api/data/Common/GetDomainResult";
const log = Log.create("CommonStore");
class CommonStore {
    badgeList = new HanyoListViewModel();
    messages = {};
    domainConfig = new GetDomainResult();
    mypageTableSetting = new MypageTableSetting();
    publicKey = "";
    informationTermsOfUseVersion = "";
    initError = false;
    menuInfo = [];
    topPageMenuInfo = [];
    displayInfo = [];
    menubarLinkInfo = [];
    async init() {
        this.initError = false;
        try {
            const msg = await api.common.getMessages();
            const key = await api.common.getKey();
            this.publicKey = key;
            this.messages = JSON.parse(msg.messages);
            const domainConfig = await api.common.getDomain();
            this.domainConfig.manage = atob(domainConfig.manage);
            this.domainConfig.manageInside = atob(domainConfig.manageInside);
            if (!auth.isAuthenticated) {
                return;
            }
            const setting = await api.common.getSetting();
            this.mypageTableSetting = setting.mypageTableSetting;
            this.badgeList = new HanyoListViewModel(setting.badgeList);
            this.informationTermsOfUseVersion = setting.informationTermsOfUseVersion;
            this.menuInfo = setting.menuInfo;
            this.topPageMenuInfo = setting.topPageMenuInfo;
            this.displayInfo = setting.displayInfo;
            this.menubarLinkInfo = setting.menubarLinkInfo;
        }
        catch (ex) {
            this.initError = true;
            throw ex;
        }
    }
    clear() {
        this.clear();
    }
    pageName(pageID) {
        return this.displayInfo.find(x => x.displayID === pageID)?.displayShortName ?? "";
    }
}
export let commonStore = reactive(new CommonStore());
